import React from 'react';

/**
 * Inline Feather-style SVG icons for the new shell. Defined here (rather than
 * pulled from `react-icons/fi`) so we control stroke width / line caps and
 * keep the bundle lean. Keep the prop API minimal: `size`, `className`.
 */
export const Icon = ({ d, size = 18, fill = 'none', stroke = 2, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke="currentColor"
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {d}
  </svg>
);

export const IcoHome = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M3 9.5 12 3l9 6.5V21H3z" />
        <path d="M9 21V12h6v9" />
      </>
    }
  />
);
export const IcoApple = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M12 7c1-2 3-3 5-3 0 2-1 4-3 5" />
        <path d="M17 9c2 0 4 2 4 5 0 4-3 8-6 8-1 0-2-.5-3-.5s-2 .5-3 .5c-3 0-6-4-6-8 0-3 2-5 4-5 1 0 2 .5 3 .5s2-.5 3-.5z" />
      </>
    }
  />
);
export const IcoChart = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M3 3v18h18" />
        <path d="m7 14 4-4 3 3 5-6" />
      </>
    }
  />
);
export const IcoBook = (p) => (
  <Icon
    {...p}
    d={<path d="M4 4h12a3 3 0 0 1 3 3v13H7a3 3 0 0 1-3-3z M4 17a3 3 0 0 1 3-3h12" />}
  />
);
export const IcoUsers = (p) => (
  <Icon
    {...p}
    d={
      <>
        <circle cx="9" cy="8" r="4" />
        <path d="M2 21c0-4 3-7 7-7s7 3 7 7" />
        <circle cx="17" cy="6" r="3" />
        <path d="M22 19c0-3-2-5-5-5" />
      </>
    }
  />
);
export const IcoDumb = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M2 9v6" />
        <path d="M5 6v12" />
        <path d="M9 4v16" />
        <path d="M15 4v16" />
        <path d="M19 6v12" />
        <path d="M22 9v6" />
      </>
    }
  />
);
export const IcoLib = (p) => (
  <Icon
    {...p}
    d={
      <>
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
      </>
    }
  />
);
export const IcoSettings = (p) => (
  <Icon
    {...p}
    d={
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
      </>
    }
  />
);
export const IcoLock = (p) => (
  <Icon
    {...p}
    d={
      <>
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </>
    }
  />
);
export const IcoBell = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M14 21a2 2 0 0 1-4 0" />
      </>
    }
  />
);
export const IcoSearch = (p) => (
  <Icon
    {...p}
    d={
      <>
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
      </>
    }
  />
);
export const IcoChevR = (p) => <Icon {...p} d={<path d="m9 18 6-6-6-6" />} />;
export const IcoMore = (p) => (
  <Icon
    {...p}
    d={
      <>
        <circle cx="5" cy="12" r="1" fill="currentColor" />
        <circle cx="12" cy="12" r="1" fill="currentColor" />
        <circle cx="19" cy="12" r="1" fill="currentColor" />
      </>
    }
  />
);
export const IcoTrend = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="m3 17 6-6 4 4 8-8" />
        <path d="M14 7h7v7" />
      </>
    }
  />
);
export const IcoMsg = (p) => (
  <Icon
    {...p}
    d={<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />}
  />
);
export const IcoTools = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M14.7 6.3a4 4 0 1 0 5 5L21 9.5V6h-3.5z" />
        <path d="M11 13 4 20a2 2 0 0 1-2.8-2.8l7-7" />
      </>
    }
  />
);
export const IcoAcademic = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M22 10 12 4 2 10l10 6 10-6z" />
        <path d="M6 12v5c2 1 4 2 6 2s4-1 6-2v-5" />
      </>
    }
  />
);
export const IcoFlame = (p) => (
  <Icon
    {...p}
    d={
      <path d="M12 2c1 4 5 5 5 10a5 5 0 1 1-10 0c0-2 1-3 2-4 0 2 1 3 3 3-2-3 0-6 0-9z" />
    }
  />
);
export const IcoCheck = (p) => <Icon {...p} d={<path d="m5 12 5 5L20 7" />} />;
export const IcoX = (p) => (
  <Icon {...p} d={<path d="M6 6l12 12M18 6L6 18" />} />
);
export const IcoPlay = (p) => (
  <Icon {...p} fill="currentColor" d={<polygon points="6 4 20 12 6 20 6 4" />} />
);
export const IcoPlus = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M12 5v14" />
        <path d="M5 12h14" />
      </>
    }
  />
);
export const IcoSparkle = (p) => (
  <Icon
    {...p}
    d={
      <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" />
    }
  />
);
export const IcoTimer = (p) => (
  <Icon
    {...p}
    d={
      <>
        <circle cx="12" cy="13" r="8" />
        <path d="M12 9v4l2 2M9 2h6" />
      </>
    }
  />
);
export const IcoTarget = (p) => (
  <Icon
    {...p}
    d={
      <>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="12" cy="12" r="1" />
      </>
    }
  />
);
export const IcoHeart = (p) => (
  <Icon
    {...p}
    d={
      <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z" />
    }
  />
);
export const IcoArrowR = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M5 12h14" />
        <path d="m13 5 7 7-7 7" />
      </>
    }
  />
);
export const IcoBolt = (p) => (
  <Icon {...p} d={<path d="m13 2-9 12h7l-1 8 9-12h-7z" />} />
);
// A heartbeat line: cardio sessions in the activity feed.
export const IcoActivity = (p) => (
  <Icon {...p} d={<path d="M22 12h-4l-3 9L9 3l-3 9H2" />} />
);
// Two points joined by a path: distance.
export const IcoRoute = (p) => (
  <Icon
    {...p}
    d={
      <>
        <circle cx="6" cy="19" r="3" />
        <circle cx="18" cy="5" r="3" />
        <path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" />
      </>
    }
  />
);
export const IcoMenu = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M3 6h18" />
        <path d="M3 12h18" />
        <path d="M3 18h18" />
      </>
    }
  />
);
export const IcoFilter = (p) => (
  <Icon {...p} d={<path d="M22 3H2l8 9.5V19l4 2v-8.5z" />} />
);
export const IcoEdit = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M11 4H4v16h16v-7" />
        <path d="m18.5 2.5 3 3L12 15l-4 1 1-4z" />
      </>
    }
  />
);
